module.exports = __webpack_public_path__ + "static/media/IconTemplates_-78.f17e9b41.svg";